import { extendDeep } from '../../utils/utils';
import { defaultSettings } from './settings';
import { initItems } from './items';
import { initHttp } from '../../utils/http';
import { addEvents } from '../decorators';
import { eventsList } from '../../events/list';
import { CorrelationId } from '../../utils/CorrelationId';
import { initFolders } from './folders';
import { UnsplashSourceName } from './constants';
export function Unsplash(userSettings) {
  if (userSettings === void 0) {
    userSettings = {};
  }
  this.siteMediaToken = userSettings.siteMediaToken;
  const settings = extendDeep(userSettings.metaSiteToken ? {
    requestOptions: {
      headers: {
        Authorization: userSettings.metaSiteToken
      }
    }
  } : {}, defaultSettings, userSettings);
  const correlationId = new CorrelationId();
  const http = initHttp(settings.requestOptions);
  const items = initItems(settings, http);
  const folders = initFolders(settings, http);
  this.name = UnsplashSourceName;
  this.correlationId = correlationId;
  this.items = addEvents(this, eventsList.ITEMS, items);
  this.folders = addEvents(this, eventsList.FOLDERS, folders);
}